// extracted by mini-css-extract-plugin
export default {"container":"styles_container__GIUfu","ripple":"styles_ripple__au-17","content":"styles_content__lCIyS"};